jQuery(function(){

  jQuery('#headerMenuheader .sub-menu li a').each(function () {     
    this.href = this.href.replace(/(\/nihrcategory\/)([a-zA-Z0-9 \-]*)(\/)?$/g, '/browse-content/?_sft_nihrcategory=$2');
  });

});